<template>
	<v-dialog v-model="dialogUserCursoAula" max-width="800px" persistent>
		<v-card>
			<v-card-title>
				<span class="headline">{{ formTitle }}</span>
			</v-card-title>

			<v-card-text>
				<v-form ref="form">
					<v-container>
						<v-row>
							<v-col cols="12">
								<v-menu
									ref="menu"
									v-model="menu"
									:close-on-content-click="false"
									transition="scale-transition"
									offset-y
									min-width="290px"
								>
									<template v-slot:activator="{ on }">
										<v-text-field
											v-model="dateFormatted"
											label="Data de início"
											prepend-icon="event"
											readonly
											v-on="on"
										></v-text-field>
									</template>
									<v-date-picker
										v-model="date"
										no-title
										@input="menu = false"
									></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12">
								<v-text-field
									v-model="editedItem.dias_acesso"
									label="Dias de acesso"
									type="number"
									:rules="[rules.required, rules.numero]"
								></v-text-field>
							</v-col>
						</v-row>
					</v-container>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="warning" icon @click="close()" title="Fechar formulário">
					<v-icon>fal fa-times</v-icon>
				</v-btn>
				<v-btn color="success" icon @click="save()" title="Salvar formulário">
					<v-icon>fal fa-save</v-icon>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
	inheritAttrs: false,
	props: {
		userCursoId: undefined,
		aula: {},
		typeForm: {
			default: 0,
		},
	},
	data() {
		return {
			server: 'user_curso',
			editedItem: {
				data_inicio: null,
				dias_acesso: 0,
			},
			date: new Date().toISOString().substr(0, 10),
			dateFormatted: null,
			menu: false,
		}
	},
	watch: {
		date(val) {
			this.dateFormatted = this.formatDate(this.date)
			this.editedItem.data_inicio = this.date
		},
		// editedItem: {
		// 	deep: true,
		// 	handler(editedItem) {
		// 		this.editedItem.dias_acesso = this.editedItem.dias_acesso.replace('.', '')
		// 		this.editedItem.dias_acesso = this.editedItem.dias_acesso.replace('e', '')
		// 	},
		// },
	},
	computed: {
		...mapState(['user', 'rules', 'dialogUserCursoAula']),
		formTitle() {
			return this.typeForm === 0 ? 'Cadastrar' : 'Editar'
		},
	},
	created() {
		if (this.typeForm === 1) {
			this.editedItem = Object.assign({}, this.aula)
			this.date = this.editedItem.data_inicio
		} else {
			this.editedItem.data_inicio = this.date
		}
		this.dateFormatted = this.formatDate(this.date)
	},

	methods: {
		formatDate(date) {
			if (!date) return null
			const [year, month, day] = date.split('-')
			return `${day}/${month}/${year}`
		},
		close() {
			this.$store.dispatch('dialogUserCursoAula', { value: false })
			setTimeout(() => {
				this.$emit('changeTypeForm', { typeForm: 0, hideForm: 'userCursoAula' })
			}, 300)
		},

		save() {
			if (this.$refs.form.validate()) {
				if (this.typeForm === 0) {
					let formData = new FormData()
					formData.append('menu', this.server)
					formData.append('function', 'insert_user_curso_aula')
					formData.append('user_id', this.user.id)
					formData.append('user_curso_id', this.userCursoId)
					formData.append('aula_id', this.aula.id)
					formData.append('data_inicio', this.editedItem.data_inicio)
					formData.append('dias_acesso', this.editedItem.dias_acesso)
					let vd = this
					this.$axiosPost
						.post('functions.php', formData, {
							headers: { Authorization: this.user.token },
						})
						.then(function(response) {
							if (response.data.error === 0) {
								vd.$store.dispatch('alert', {
									alertMessage: response.data.alertMessage,
									alertType: 0,
								})
								vd.$store.dispatch('searchUserCursos', { value: true })
								vd.close()
							} else {
								vd.$store.dispatch('errorServer', {
									data: response.data,
									destination: vd.$route.path,
								})
							}
						})
						.catch(function(response) {
							console.log('ERROR!! ' + response)
						})
				} else {
					let formData = new FormData()
					formData.append('menu', this.server)
					formData.append('function', 'update_user_curso_aula')
					formData.append('user_id', this.user.id)
					formData.append('user_curso_id', this.userCursoId)
					formData.append('aula_id', this.aula.id)
					formData.append('data_inicio', this.editedItem.data_inicio)
					formData.append('dias_acesso', this.editedItem.dias_acesso)
					let vd = this
					this.$axiosPost
						.post('functions.php', formData, {
							headers: { Authorization: this.user.token },
						})
						.then(function(response) {
							if (response.data.error === 0) {
								vd.close()
								vd.$store.dispatch('alert', {
									alertMessage: response.data.alertMessage,
									alertType: 0,
								})
								vd.$store.dispatch('searchUserCursos', { value: true })
							} else {
								vd.$store.dispatch('errorServer', {
									data: response.data,
									destination: vd.$route.path,
								})
							}
						})
						.catch(function(response) {
							console.log('ERROR!! ' + response)
						})
				}
			}
		},
	},
}
</script>
